import React from "react";

const STATUS_COPY = {
  loading: ["Loading artifact", "Preparing artifact viewer."],
  not_found: [
    "Artifact not found",
    "This artifact link is invalid or no longer exists.",
  ],
  unauthorized: [
    "Access required",
    "You do not have permission to open this artifact.",
  ],
  email_required: [
    "Email verification required",
    "Verify your email to continue.",
  ],
  auth_required: ["Sign in required", "Sign in to open this artifact."],
  disabled: [
    "Artifact unavailable",
    "This artifact is not currently accepting responses.",
  ],
  expired: [
    "Artifact expired",
    "This artifact is no longer accepting responses.",
  ],
  revoked: ["Artifact revoked", "This artifact link has been revoked."],
  already_completed: [
    "Already completed",
    "This artifact has already been submitted.",
  ],
  submitted: ["Submitted", "Your response has been recorded."],
  load_failed: [
    "Artifact unavailable",
    "We could not load this artifact. Please try again.",
  ],
  submit_failed: [
    "Submission failed",
    "We could not submit this artifact. Please try again.",
  ],
};

export default function ArtifactStatusScreen({ status, message }) {
  const [title, fallback] = STATUS_COPY[status] || STATUS_COPY.submit_failed;
  return (
    <div className="artifact-status-screen" role="status">
      <div className={`artifact-status-card artifact-status-card--${status}`}>
        <div className="artifact-status-icon" aria-hidden="true">
          {status === "loading" ? (
            <span className="artifact-status-spinner" />
          ) : null}
        </div>
        <h1>{title}</h1>
        <p>{message || fallback}</p>
      </div>
    </div>
  );
}
